import React, { useState } from 'react';

const RejectionModal = ({ isOpen, onClose, onSubmit, isRejecting }) => {
  const [disapprovalNotes, setDisapprovalNotes] = useState('');

  const handleSubmit = () => {
    if (!disapprovalNotes.trim()) {
      alert('Error: Please provide a disapproval reason.');
      return;
    }
    onSubmit(disapprovalNotes);
  };

  return (
    <div
      className={`modal fade ${isOpen ? 'show d-block' : ''}`}
      id="rejection-modal"
      tabIndex="-1"
      aria-labelledby="rejectionModalLabel"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center">
            <h4 className="modal-title" id="rejectionModalLabel">
              Disapprove Case
            </h4>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="disapprovalNotes" className="form-label">
                Reason for Disapproval
              </label>
              <textarea
                className="form-control"
                id="disapprovalNotes"
                rows="4"
                value={disapprovalNotes}
                onChange={(e) => setDisapprovalNotes(e.target.value)}
                placeholder="Enter the reason for disapproving this case"
              ></textarea>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn bg-danger-subtle text-danger font-medium"
              onClick={onClose}
              disabled={isRejecting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isRejecting}
            >
              {isRejecting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;